import { NgModule } from '@angular/core';
import { savedCartTranslationChunksConfig, savedCartTranslationsEn } from '@spartacus/cart/saved-cart/assets';
import { CART_SAVED_CART_FEATURE, SavedCartRootModule } from '@spartacus/cart/saved-cart/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { SavedCartItemsModule } from './saved-cart/components/details/saved-cart-items/saved-cart-items.module';
import { SavedCartDetailsActionModule } from './saved-cart/components/details/saved-cart-details-action/saved-cart-details-action.module';
import { defaultImportExportConfig } from '@spartacus/cart/import-export/core';

@NgModule({
  declarations: [],
  imports: [SavedCartRootModule, SavedCartItemsModule, SavedCartDetailsActionModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_SAVED_CART_FEATURE]: {
          module: () => import('./saved-cart/saved-cart.module').then(m => m.CustomSavedCartModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: savedCartTranslationsEn },
        chunks: savedCartTranslationChunksConfig,
      },
    }),
    provideConfig(defaultImportExportConfig),
  ],
})
export class CartSavedCartFeatureModule {}
